<script setup lang="ts">
import { ConnectedAccountsEmbed } from '@/Pejer/tables/ConnectedAccounts'
import { AlertCircle } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import { computed } from 'vue'
import DirectPaymentAccountOnboardingModal from '../DirectPaymentAccount/DirectPaymentAccountOnboardingModal.vue'
import PersonOfInterestModal from './PersonOfInterestModal.vue'

const props = defineProps<{
  connectedAccount: ConnectedAccountsEmbed.ListItem
}>()

const statusText = computed(() => {
  if (!props.connectedAccount.tosAcceptedAt) return 'Vilkår ikke akseptert'
  if (!props.connectedAccount.signatureCompletedAt) return 'Signatur mangler'
  return props.connectedAccount.statusInfo
})
</script>
<template>
  <span v-if="connectedAccount.payoutsEnabled">
    <DirectPaymentAccountOnboardingModal
      v-if="
        connectedAccount.isDirectPaymentAccount &&
        connectedAccount.directPaymentAccountStatus === 'AwaitingReadConfirmation'
      "
      :businessName="connectedAccount.businessName"
      :organizationId="connectedAccount.organizationId"
      :countryCode="connectedAccount.countryCode"
      :bban="connectedAccount.bban"
      :contactPostalCode="connectedAccount.individualZipcode"
      :contactPersonName="
        connectedAccount.individualFirstname + ' ' + connectedAccount.individualLastname
      "
      :contactPersonEmail="connectedAccount.individualEmail"
    >
      <Button variant="outline" class="hover:text-red-900 text-red-600">
        <AlertCircle class="w-4 h-4 mr-2" /> Venter på bankbekreftelse på direktekonto
      </Button>
    </DirectPaymentAccountOnboardingModal>
    <span v-else class="text-green-500">Ok</span>
  </span>
  <span v-else>
    <PersonOfInterestModal :connectedAccount="connectedAccount">
      <Button variant="outline" class="hover:text-red-900 text-red-600">
        <AlertCircle class="w-4 h-4 mr-2" /> {{ statusText }}
      </Button>
    </PersonOfInterestModal>
  </span>
</template>
